module.exports = __webpack_public_path__ + "static/img/20200518-04.713c9f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-04.png
// module id = RGyz
// module chunks = 1